import { getApiClient } from '@src/services/api-client'
import { useQuery } from '@tanstack/react-query'

// Query Keys
export const vehicleKeys = {
  all: ['vehicle'] as const,
  maxTerm: (year: number, mileage: number, plan?: string) =>
    [...vehicleKeys.all, 'maxTerm', year, mileage, plan] as const,
}

// Types
interface GetMaxTermParams {
  year: number
  mileage: number
  plan?: string
}

// API Functions
async function getMaxTerm({ year, mileage, plan }: GetMaxTermParams): Promise<number> {
  const apiClient = getApiClient()
  let url = `/vehicle/maxterm?year=${year}&mileage=${mileage}`
  if (plan) {
    url += `&plan=${encodeURIComponent(plan)}`
  }
  const response = await apiClient.get<number>(url)
  return response.data
}

// React-Query Hooks
export function useGetVehicleMaxTerm(params: GetMaxTermParams | null): [number, boolean] {
  const year = params?.year ?? 0
  const mileage = params?.mileage ?? 0
  const plan = params?.plan

  const { data, isFetching } = useQuery({
    queryKey: vehicleKeys.maxTerm(year, mileage, plan),
    queryFn: () => getMaxTerm({ year, mileage, plan }),
    enabled: !!params && year > 0 && mileage >= 0,
  })
  return [data ?? 0, isFetching]
}
